import { FC, useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';

import { DatePicker } from '@beeline/design-system-react/extracted-styles';

import { getParkingState } from 'src/store/parking/selectors';
import { parkingActions } from 'src/store/parking/slice';
import { calculateDateBounds } from 'src/store/rooms/utils';
import { useAppDispatch } from 'src/store/useAppDispatch';

export const ParkingBookingDateField: FC = () => {
  const dispatch = useAppDispatch();
  const { backgroundData, date, dateError, town } =
    useSelector(getParkingState);
  const { min, max } = useMemo(
    () =>
      town?.timeZone !== undefined
        ? calculateDateBounds(town.timeZone)
        : { min: undefined, max: undefined },
    [town?.timeZone],
  );

  const dateDisabled = !backgroundData;

  const setDate = useCallback(
    (value: string | undefined) => {
      dispatch(parkingActions.setDate(value));
    },
    [dispatch],
  );

  return (
    <DatePicker
      label='Дата'
      minDate={min?.toISOString()}
      maxDate={max?.toISOString()}
      onChange={setDate}
      value={date}
      error={!!dateError}
      helperText={dateError}
      dataTestId='parkingBookingDate'
      disabled={dateDisabled}
      fullWidth
    />
  );
};
